import {Component, inject, Input, ChangeDetectionStrategy} from '@angular/core';
import {ImageUploadComponent} from "../image-upload/image-upload.component";
import {Project, ProjectControllerService} from "../../../api";
import {Observable} from "rxjs";
import {ImageCropperComponent} from "../image-upload/image-cropper/image-cropper.component";
import {ViewImageComponent} from "../image-upload/view-image/view-image.component";
import {MatDialog} from "@angular/material/dialog";
import {TooltipDirective} from '@buildinginformationcloud/bic-ui-components';

/**
 * Upload of a Project Image
 */
@Component({
    selector: 'app-project-image-upload',
    templateUrl: '../image-upload/image-upload.component.html',
    styleUrls: ['../image-upload/image-upload.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TooltipDirective],
})
export class ProjectImageUploadComponent extends ImageUploadComponent {
  private projectControllerService = inject(ProjectControllerService);
  private dialog = inject(MatDialog);


  /**
   * Project for image
   */
  @Input() project!: Project;

  /**
   * Initialization of Component
   */
  ngOnInit(): void {
  }

  /**
   * Uploads the Image using S3
   * @param event upload Event
   */
  uploadImage(event: any) {
    const files = event.target.files as FileList;
    if (files.length > 0) {
      let filename = files[0].name;
      let fileType = files[0].type;
      const _file = URL.createObjectURL(files[0]);
      this.resetInput();
      this.openAvatarEditor(_file)
        .subscribe(
          async (result) => {
            if(result){
              let croppedFile = await this.urlToFile(result, filename, fileType);
              this.projectControllerService.updateImageForm(croppedFile, this.project.id!)
                .subscribe(
                  (data) => {
                    super.setImage(data.image);
                  })
            }
          }
        )
    }



    this.projectControllerService.updateImageForm(event.target.files[0], this.project.id!).subscribe((project) => {
      super.setImage(project.image);
    })
  }

  async urlToFile(url: string, filename: string, mimeType: string): Promise<File> {
    const response = await fetch(url);
    const blob = await response.blob();
    return new File([blob], filename, { type: mimeType });
  }

  resetInput(){
    const input = document.getElementById('imageInput') as HTMLInputElement;
    if(input){
      input.value = "";
    }
  }

  openAvatarEditor(image: string): Observable<any> {
    const dialogRef = this.dialog.open(ImageCropperComponent, {
      panelClass: 'rounded-corners-dialog',
      data: image,
    });

    return dialogRef.afterClosed();
  }

  openImageOptions(image: string | undefined){
    let dialogRef = this.dialog.open(ViewImageComponent, {
      panelClass: 'rounded-corners-dialog',
      width: '750px',
      data: {image: image},
    });

    dialogRef.afterClosed().subscribe((result) => {
      if(result === 'remove'){
        this.projectControllerService.removeImage1(this.project.id!).subscribe( () => {
          super.setImage(undefined);
        })
      }else if(result === 'upload'){
        super.triggerClickOnInput()
      }
    });

  }


}
